interface ConfirmRequiredHttpError {
  status?: number;
  error?: unknown;
}

function parseErrorBody(errorBody: unknown): Record<string, unknown> | null {
  if (errorBody && typeof errorBody === 'object') {
    return errorBody as Record<string, unknown>;
  }

  if (typeof errorBody === 'string') {
    try {
      const parsed = JSON.parse(errorBody) as unknown;
      return parsed && typeof parsed === 'object' ? (parsed as Record<string, unknown>) : null;
    } catch {
      return null;
    }
  }

  return null;
}

function readStatusCode(error: ConfirmRequiredHttpError): number | undefined {
  const body = parseErrorBody(error.error);

  if (typeof error.status === 'number' && !Number.isNaN(error.status)) {
    return error.status;
  }

  if (!body) {
    return undefined;
  }

  for (const key of ['StatusCode', 'statusCode']) {
    const value = body[key];
    if (typeof value === 'number' && !Number.isNaN(value)) {
      return value;
    }
  }

  return undefined;
}

/** True when API requires user confirmation before continuing (HTTP/body status 428). */
export function isConfirmRequiredDuplicateError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }

  return readStatusCode(error as ConfirmRequiredHttpError) === 428;
}
